module.exports = __webpack_public_path__ + "img/17-21.a51f16dd.jpg";